import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { PageHeader } from "../../../../components/page-header";
import { useAnimalBreedTypes } from "./useAnimalBreedFarmTypes";
import { AddAnimalBreedFarmTypeModal } from "./AddAnimalBreedFarmTypeModal";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetAnimalBreedFarmTypeListQuery } from "../../../../redux/api/handBooksApi/animalBreadFarmTypeApi";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../../models/filters/initialFilterName";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import _ from "lodash";
import { useForm } from "antd/es/form/Form";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name
}

export const AnimalBreedFarmTypes = () => {
  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedAnimalBreed, setSelectedAnimalBreed] = useState<EntDirectoryInfoName>(new EntDirectoryInfoName());
  const [showModal, setShowModal] = useState<boolean>(false);
  const {
	onAddAnimalBreedFarmType,
	onEditAnimalBreedFarmType,
	onDeleteAnimalBreedFarmType
  } = useAnimalBreedTypes(modal, () => {
	searchHandleClick()
  })

  const [getArchiveFolders] = useLazyGetAnimalBreedFarmTypeListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntDirectoryInfoName, EntInitialFilterName>({
	initialFilter: new EntInitialFilterName(),
	query: getArchiveFolders
  });

  const [height, setHeight] = useState<number>(0);

  const openAddModal = (item: EntDirectoryInfoName) => {
	setSelectedAnimalBreed(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntInitialFilterName => {
	let item: EntInitialFilterName = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null }
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteAnimalBreedFarmType(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.types_of_farms') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntDirectoryInfoName)
		} }>
		  { t('handbooks.types_of_farms.add_types_of_farms') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick }
											 onReset={ () => {
											   clearFields();
											   searchHandleClick()
											 } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 700 }
	  />
	  <AddAnimalBreedFarmTypeModal
		animalBreed={ selectedAnimalBreed }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedAnimalBreed.id !== 0 ? onEditAnimalBreedFarmType : onAddAnimalBreedFarmType }
	  />
	  { contextHolder }
	</>
  )
}
